<template>
  <section id="service" class="service-wrap ptb-100 bg-albastor">
    <div class="container">
      <div class="row">
        <div class="col-xl-6 offset-xl-3 col-lg-8 offset-lg-2">
          <div class="section-title style3 text-center mb-40">
            <span>What's Happening</span>
            <h2>We're <span>Providing Best Services</span> To Our Customers</h2>
          </div>
        </div>
      </div>

      <Carousel
        :autoplay="5000"
        :wrap-around="true"
        :breakpoints="breakpoints"
        pause-autoplay-on-hover
        class="service-slider-two"
      >
        <Slide v-for="service in services" :key="service.id">
          <div class="service-card style3">
            <div class="service-info">
              <span class="service-icon">
                <i :class="service.icon"></i>
              </span>
              <h3>
                <router-link to="/service-details">
                  {{ service.title }}
                </router-link>
              </h3>
              <p>{{ service.shotDesc }}</p>
              <ul class="content-feature-list list-style">
                <li v-for="feature in service.features" :key="feature.id">
                  <i class="ri-check-double-line"></i>
                  {{ feature.feature }}
                </li>
              </ul>
            </div>
          </div>
        </Slide>

        <template #addons>
          <Navigation />
        </template>
      </Carousel>
    </div>
  </section>
</template>

<script>
import { defineComponent } from "vue";
import { Carousel, Slide, Navigation } from "vue3-carousel";

export default defineComponent({
  name: "BestServices",
  components: {
    Carousel,
    Slide,
    Navigation,
  },
  data: () => ({
    settings: {
      itemsToShow: 1,
      snapAlign: "center",
    },
    services: [
      {
        id: 1,
        icon: "flaticon-swab",
        title: "Covid-19 Exhortation",
        shotDesc:
          "It is a long established fact that reader will also may be distracted when looking reading.",

        features: [
          {
            id: 1,
            feature: "Cancer Services",
          },
          {
            id: 2,
            feature: "Cardiovascular Services",
          },
          {
            id: 3,
            feature: "Weight Management",
          },
        ],
      },
      {
        id: 2,
        icon: "flaticon-heartbeat",
        title: "Health Checkup",
        shotDesc:
          "It is a long established fact that reader will also may be distracted when looking reading.",

        features: [
          {
            id: 1,
            feature: "Cancer Services",
          },
          {
            id: 2,
            feature: "Heart Checkup",
          },
          {
            id: 3,
            feature: "Weight Management",
          },
        ],
      },
      {
        id: 3,
        icon: "flaticon-dermatologically-tested",
        title: "Dermetalogy Services",
        shotDesc:
          "It is a long established fact that reader will also may be distracted when looking reading.",

        features: [
          {
            id: 1,
            feature: "Cardiovascular Services",
          },
          {
            id: 2,
            feature: "Cancer Services",
          },
          {
            id: 3,
            feature: "Full Health Checkup",
          },
        ],
      },
      {
        id: 4,
        icon: "flaticon-massage",
        title: "Clinical Surgery",
        shotDesc:
          "It is a long established fact that reader will also may be distracted when looking reading.",

        features: [
          {
            id: 1,
            feature: "Cancer Services",
          },
          {
            id: 2,
            feature: "Weight Management",
          },
          {
            id: 3,
            feature: "Cardiovascular Services",
          },
        ],
      },
      {
        id: 5,
        icon: "flaticon-laser",
        title: "Post Covid Care",
        shotDesc:
          "It is a long established fact that reader will also may be distracted when looking reading.",

        features: [
          {
            id: 1,
            feature: "Fitness Management",
          },
          {
            id: 2,
            feature: "Cancer Services",
          },
          {
            id: 3,
            feature: "Cardiovascular Services",
          },
        ],
      },
    ],
    breakpoints: {
      0: {
        itemsToShow: 1,
        snapAlign: "center",
      },
      768: {
        itemsToShow: 2,
        snapAlign: "start",
      },
      1200: {
        itemsToShow: 3,
        snapAlign: "center",
      },
    },
  }),
});
</script>